<button
  [type]="type"
  [disabled]="disabled"
  class="inline-flex items-center justify-center gap-2 rounded-md px-6 py-3 font-extrabold tracking-wide transition-base duration-base border-0 outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0"
  [ngClass]="{
    'bg-primary text-white shadow-sm hover:bg-primary-hover hover:shadow-md hover:-translate-y-px active:translate-y-0 active:shadow-sm': variant === 'primary',
    'bg-primary-light text-primary hover:bg-primary hover:text-white hover:-translate-y-px active:translate-y-0': variant === 'secondary',
    'bg-bg-app text-text-main hover:bg-primary-light hover:text-primary': variant === 'ghost',
    'w-full': fullWidth
  }"
>
  <ng-content></ng-content>
</button>
